module.exports = __webpack_public_path__ + "img/u806.6d5720ec.svg";